<mat-toolbar class="example-toolbar">
    <img class="logo-cofide" *ngIf="!deviceXs" src="assets/img/Logo-COFIDE.png" routerLink="/home/inicio" alt="Logo de COFIDE">

    <img *ngIf="deviceXs" src="assets/img/Logo-COFIDE.png" width="138" style="cursor: pointer; "
      routerLink="/home/inicio"  alt="Logo de COFIDE">
  
    <span class="example-spacer"></span>
    <span>{{ username }}</span>
    <button mat-icon-button [matMenuTriggerFor]="menu">
      <mat-icon class="icon-display">account_circle</mat-icon>
    </button>
  
    <mat-menu #menu="matMenu">
      <button mat-menu-item (click)="CerraSessionMain()">
        <mat-icon>exit_to_app</mat-icon>
        <span>Cerrar Sesión</span>
      </button>
    </mat-menu>
  </mat-toolbar>
  <div class="example-container">
  
    <mat-sidenav-container class="body-container">
      <router-outlet></router-outlet>
    </mat-sidenav-container>
  </div>
  
  <footer class="footer">
    <span class="footer-text">&copy; 2023 - Todos los derechos reservados</span>
  </footer>